import { useState, useEffect, useRef } from 'react';

const STORAGE_KEY = 'pacientes_filters';

const loadFiltersFromStorage = () => {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored) {
      return JSON.parse(stored);
    }
  } catch (error) {
    console.error('Erro ao carregar filtros do storage:', error);
  }
  return {
    searchInput: '',
    searchTerm: '',
    statusFilter: '',
    modalityFilter: '',
    shiftFilter: ''
  };
};

const saveFiltersToStorage = (filters) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(filters));
  } catch (error) {
    console.error('Erro ao salvar filtros no storage:', error);
  }
};

export const usePacientesFilters = () => {
  const [filters, setFilters] = useState(() => loadFiltersFromStorage());
  const isInitialMount = useRef(true);

  // Salvar filtros no storage sempre que mudarem (exceto no mount inicial)
  useEffect(() => {
    if (!isInitialMount.current) {
      saveFiltersToStorage(filters);
    } else {
      isInitialMount.current = false;
    }
  }, [filters]);

  const updateFilter = (key, value) => {
    setFilters(prev => ({ ...prev, [key]: value }));
  };

  const resetFilters = () => {
    const defaultFilters = {
      searchInput: '',
      searchTerm: '',
      statusFilter: '',
      modalityFilter: '',
      shiftFilter: ''
    };
    setFilters(defaultFilters);
    saveFiltersToStorage(defaultFilters);
  };

  return {
    filters,
    updateFilter,
    setFilters,
    resetFilters
  };
};


